import { Component, Input, OnInit, OnDestroy, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { PlaylistService } from '../../services/playlist.service';
import { Playlist } from '../../interfaces/playlist.interface';
import { Unsubscribe } from '@angular/fire/firestore';

@Component({
  selector: 'app-playlist-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './playlist-grid.component.html',
  styleUrls: ['./playlist-grid.component.scss']
})
export class PlaylistGridComponent implements OnInit, OnDestroy {
  private playlistService = inject(PlaylistService);
  private platformId = inject(PLATFORM_ID);
  private playlistsListener?: Unsubscribe;

  /** Cap how many cards render — used on Home; the dedicated page and modal leave this unset. */
  @Input() limit?: number;

  playlists: Playlist[] = [];
  loading = true;
  skeletons = [1, 2, 3, 4];

  get visiblePlaylists(): Playlist[] {
    const sorted = [...this.playlists].sort((a, b) => (a.featured === b.featured ? 0 : a.featured ? -1 : 1));
    return this.limit ? sorted.slice(0, this.limit) : sorted;
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.playlistsListener = this.playlistService.listenToPublishedPlaylists((playlists) => {
        this.playlists = playlists;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }

  ngOnDestroy() {
    this.playlistsListener?.();
  }

  getPlatformIcon(platform: string): string {
    const icons: Record<string, string> = {
      spotify: 'bi bi-spotify',
      apple: 'bi bi-apple',
      soundcloud: 'bi bi-soundwave',
      youtube: 'bi bi-youtube'
    };
    return icons[platform] || 'bi bi-music-note-beamed';
  }

  getPlatformLabel(platform: string): string {
    const labels: Record<string, string> = {
      spotify: 'Spotify',
      apple: 'Apple Music',
      soundcloud: 'SoundCloud',
      youtube: 'YouTube'
    };
    return labels[platform] || 'Listen';
  }
}
